import { useEffect } from 'react';
import { useTranslations } from 'next-intl';
import { GlowSkeleton } from '@headless-workspace/glow-ds';
import { Component } from '@headless-workspace/typings';
import { LocalityDetails, StoreInfoValue } from '../../../../server';
import { NoStoreFound } from './NoStoreFound';
import { DisplayOption } from './StoresDeliveryContainer';
import { StoreSelectionMenuMap } from './map';
import { StoresList } from './storeDeliveryContainer/StoresList';
import { StoreRecoveryStatus } from './useStoreInfos';

type StoreSliderDisplayProps = {
    stores: StoreInfoValue[];
    storesRecoveryStatus: StoreRecoveryStatus;
    userPosition: GeolocationPosition | null;
    displayOption: DisplayOption;
    highlightedStoreId?: string;
    setHighlightedStore: (store: StoreInfoValue) => void;
    favoriteStoreId: string;
    currentTime: string;
    localityDetails?: LocalityDetails | null;
    setIsMoreStoresVisible: (visible: boolean) => void;
    displayMoreStoresVisibleButton: boolean;
};

export const StoreSliderDisplay: Component<StoreSliderDisplayProps> = ({
    stores,
    storesRecoveryStatus,
    userPosition,
    displayOption,
    highlightedStoreId,
    setHighlightedStore,
    favoriteStoreId,
    currentTime,
    localityDetails,
    setIsMoreStoresVisible,
    displayMoreStoresVisibleButton,
}) => {
    const t = useTranslations('Modal.stores');

    useEffect(() => {
        setIsMoreStoresVisible(false);
    }, [localityDetails, setIsMoreStoresVisible]);

    if (storesRecoveryStatus === 'init' || storesRecoveryStatus === 'error') {
        return null;
    }

    if (storesRecoveryStatus === 'loading') {
        if (displayOption === DisplayOption.Map) {
            return (
                <GlowSkeleton
                    containerClassName={'h-full w-full'}
                    height={'100%'}
                    width={'100%'}
                    itemClassName={'!rounded-0'}
                />
            );
        }
        // FIXME: This will change when list skeleton will be implemented in FHEAD-2534
        return null;
    }

    if (stores.length === 0) {
        return <NoStoreFound />;
    }

    if (displayOption === DisplayOption.Map) {
        return (
            <StoreSelectionMenuMap
                highlightedStoreId={highlightedStoreId}
                setHighlightedStore={setHighlightedStore}
                stores={stores}
                currentUserPosition={userPosition}
                favoriteStoreId={favoriteStoreId}
                localityDetails={localityDetails}
            />
        );
    }

    return (
        <StoresList
            favoriteStoreId={favoriteStoreId}
            stores={stores}
            listCaption={t('list.label.informationLastUpdatedTime', {
                currentTime,
            })}
            setHighlightedStore={setHighlightedStore}
            highlightedStoreId={highlightedStoreId}
            onMoreStoresVisibleClick={setIsMoreStoresVisible}
            displayMoreStoresVisibleButton={displayMoreStoresVisibleButton}
        />
    );
};
